import React from "react";
import { Link } from "react-router-dom";
import { Caravan, ArrowRight } from "lucide-react";
import { TOWING_PROMO } from "../../data/promo";

export default function PromoBar() {
  return (
    <Link
      to={TOWING_PROMO.path}
      data-testid="promo-bar"
      className="group block bg-cyan-pz text-black"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-2 flex items-center justify-center gap-3 text-center">
        <Caravan className="w-4 h-4 shrink-0 hidden sm:block" />
        <span className="bebas tracking-[0.12em] text-sm md:text-base leading-tight">
          <span className="hidden md:inline">{TOWING_PROMO.barText}</span>
          <span className="md:hidden">TOW READY PACKAGES FROM $1,250 — SAVE UP TO $180.</span>
        </span>
        <span className="hidden sm:inline-flex items-center gap-1 bebas tracking-widest text-sm border-b-2 border-black group-hover:gap-2 transition-all whitespace-nowrap">
          {TOWING_PROMO.barCta} <ArrowRight className="w-3.5 h-3.5" />
        </span>
      </div>
    </Link>
  );
}
